import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useToastEffect } from "../hooks.ts";
import { useCreateUserFeedbackMutation } from "../services/feedbackApi.ts";
import { useModalFocusObserver } from "./ModalFocusObserver.tsx";
import Modal from "./modal.tsx";

export const FeedBackForm = () => {
  const [inputValue, setInputValue] = useState("");

  const { t } = useTranslation(["feedbackForm"]);
  const modalRef = useRef<HTMLDialogElement | null>(null);
  const inputRef = useRef<HTMLTextAreaElement | null>(null);

  const [createUserFeedback, { isError, isSuccess, error }] =
    useCreateUserFeedbackMutation();

  useToastEffect({
    isError,
    isSuccess,
    error,
    successMessage: t("feedbackSent"),
  });

  useModalFocusObserver(modalRef, inputRef);

  const content = (
    <>
      <span>{t("feedbackForm:feedbackInfo")}</span>

      <textarea
        value={inputValue}
        ref={inputRef}
        placeholder={t("feedbackPlaceholder")}
        className="mt-sm h-52 w-full resize-none rounded-lg border-2 bg-neutral p-2 focus:outline-none"
        onChange={(event) => setInputValue(event.target.value)}
      />
    </>
  );

  return (
    <Modal
      id="feedbackFormModal"
      title={t("feedback")}
      onConfirmLabel={t("sendFeedback")}
      onCancel={() => {}}
      onConfirm={() => {
        createUserFeedback({ message: inputValue });
      }}
      content={content}
      modalRef={modalRef}
    />
  );
};
